// 折线图
export const getBrokenLineOption = dataOption => {
  let dataObj = { ...dataOption };
  return {
    title: {
      text: dataObj.title || '',
      textStyle: {
        fontSize: 12
      },
      left: 20
    },
    legend: {
      right: '10%',
      data: [...dataObj.yData].map(item => item.name)
    },
    grid: {
      left: '9%',
      right: '10%',
      top: '25%',
      bottom: '20%'
    },
    backgroundColor: '#fcfcfc',
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: [...dataObj.xData],
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value'
    },
    tooltip: {
      trigger: 'axis'
    },
    series: [...dataObj.yData].map((item, index) => {
      return {
        name: { ...item }.name,
        type: 'line',
        stack: index + 1,
        data: [...{ ...item }.data]
      };
    }),
    color: [...dataObj.color]
  };
};



// WEBPACK FOOTER //
// ./src/const/EchartsConst.js